import { useMemo } from "react";

import { useSelectedMetric } from "../atoms";

import { useCustomMetrics } from "./use-custom-metrics";

export const useDisabledControls = () => {
  const { loadingState } = useCustomMetrics();
  const [selectedMetric] = useSelectedMetric();

  const loading = useMemo(() => {
    return (
      selectedMetric?.isTemplate ||
      !selectedMetric ||
      loadingState.isCreateMetricLoading ||
      loadingState.isDeleteMetricLoading ||
      loadingState.isUpdateMetricLoading ||
      loadingState.loadingCustomMetrics
    );
  }, [
    loadingState.isCreateMetricLoading,
    loadingState.isDeleteMetricLoading,
    loadingState.isUpdateMetricLoading,
    loadingState.loadingCustomMetrics,
    selectedMetric,
  ]);
  return loading;
};
